import React from "react"
import { Header } from "./styles"
import ProfileInfo from "../../profile-info"
import PropTypes from "prop-types"

const ParticipantHeader = React.forwardRef(
  (
    {
      avatar_exists,
      avatar_path,
      obfuscated,
      display_name,
      first_name,
      last_name,
      age,
      gender_string,
      pronouns_string,
      country_name,
      placement_or_interview_status,
      buttons,
      has_visa,
      hasCoverImage
    },
    ref
  ) => {
    return (
      <Header ref={ref}>
        <ProfileInfo
          avatarExists={avatar_exists}
          avatarUrl={avatar_path}
          obfuscated={obfuscated}
          displayName={display_name}
          firstName={first_name}
          lastName={last_name}
          buttons={buttons}
          country={country_name}
          gender={gender_string}
          pronouns={pronouns_string}
          age={age}
          smallOnMobile={true}
          hasVisa={has_visa}
          placementOrInterviewStatus={placement_or_interview_status}
          hasCoverImage={hasCoverImage}
        />
      </Header>
    )
  }
)

ParticipantHeader.propTypes = {
  avatar_exists: PropTypes.bool,
  avatar_path: PropTypes.string,
  obfuscated: PropTypes.bool,
  display_name: PropTypes.string,
  first_name: PropTypes.string,
  last_name: PropTypes.string,
  age: PropTypes.number,
  gender_string: PropTypes.string,
  pronouns_string: PropTypes.string,
  country_name: PropTypes.string,
  placement_or_interview_status: PropTypes.string
}

ParticipantHeader.defaultProps = {
  avatar_exists: true,
  avatar_path: "",
  obfuscated: false,
  display_name: "",
  first_name: "",
  last_name: "",
  age: 0,
  gender_string: "",
  pronouns_string: "",
  country_name: "",
  placement_or_interview_status: ""
}

export default ParticipantHeader
